import { render } from "./HomeNews.vue?vue&type=template&id=46ba2ba8&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=js"
export * from "./HomeNews.vue?vue&type=script&lang=js"

import "./HomeNews.vue?vue&type=style&index=0&id=46ba2ba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ba2ba8"]])

export default __exports__